import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';

@Component({
	selector: 'mb-home-page-left-nav',
	templateUrl: './home-page-left-nav.component.html',
	styleUrls: ['./home-page-left-nav.component.scss']
})
export class HomePageLeftNavComponent implements OnChanges {

	@Input() public readonly selectedExploreCard: string = 'growth';
	@Output() private optionSelected: EventEmitter<string> = new EventEmitter<string>();
	@InjectConfig(ModelsExperienceConfigKey.HOME_PAGE_LEFT_NAV) public readonly homePageLeftNav: { [x: string]: Array<string> } = {
		'growth': ['all_etf', 'mutual_fund_and_etf', 'tax_aware', 'sustainable', 'high_net_growth'],
		'income': ['all_etf', 'mutual_fund_and_etf', 'tax_aware'],
		'capital_preservation': ['all_etf', 'mutual_fund_and_etf', 'tax_aware', 'sustainable', 'high_net_growth']
	};
	public selectedOption: string = '';

	constructor(private tealiumAnalyticsService: TealiumAnalyticsService) { }

	public ngOnChanges(): void {
		this.selectedOption = this.homePageLeftNav[this.selectedExploreCard][0];
		this.optionSelected.emit(this.selectedOption);
		this.emitTealiumAnalyticsEvent();
	}

	public optionClickHandler(option: string): void {
		this.selectedOption = option;
		this.emitTealiumAnalyticsEvent();
		this.optionSelected.emit(option);
	}

	private emitTealiumAnalyticsEvent() {
		const event = TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + ':' + TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_HOME_PAGE + `:left navbar:${this.selectedOption}`;
		this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent(event, {
			toolName: TealiumConstants.TOOL_NAMES.MODELS_EXPERIENCE
		}));
	}
}
